/* ── BizTrack Design System — "Modern African Business" ─────────────────── */
:root {
  /* Brand Colors — inspired by Ghana flag */
  --color-primary: #1B3A6B;        /* deep navy */
  --color-primary-light: #2E5FA3;
  --color-accent: #D4A017;         /* Ghana gold */
  --color-accent-light: #F0C040;
  --color-success: #1A7A4A;        /* deep green */
  --color-success-light: #22C55E;
  --color-danger: #C0392B;
  --color-warning: #E67E22;

  /* Surfaces */
  --color-bg: #F8F9FC;
  --color-surface: #FFFFFF;
  --color-surface-2: #F1F4F9;
  --color-border: #E2E8F0;

  /* Text */
  --color-text: #0F172A;
  --color-text-muted: #64748B;
  --color-text-light: #94A3B8;

  /* Shadows */
  --shadow-sm: 0 1px 3px rgba(0,0,0,0.08);
  --shadow-md: 0 4px 16px rgba(0,0,0,0.10);
  --shadow-lg: 0 8px 32px rgba(0,0,0,0.12);
  --shadow-gold: 0 4px 20px rgba(212,160,23,0.25);

  /* Radius */
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;

  /* Transitions */
  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-base: 250ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 400ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-spring: 500ms cubic-bezier(0.34, 1.56, 0.64, 1);
}
